import { computed } from 'vue'
import { useRoute } from 'vue-router'

export const useEventId = () => {
  const route = useRoute()
  const eventId = computed(() => Number(route.params.eventId))

  if (!eventId.value) {
    throw new Error('Missing eventId in route')
  }

  return eventId
}
